<template>
  <div class="goods-series" v-if="introduction.products&&introduction.products.length>0">
    <industry-title :title="title" :info="info"></industry-title>
    <div class="brand-list contents">
      <div
        class="swiper-series-button-prev swiper-button-prev swiper-button-white"
        v-show="introduction.products.length > 5"
      ></div>
      <div class="swiper-container-series">
        <div
          class="swiper-wrapper"
          :class="{ 'swiper-not-enough': introduction.products.length <= 5 }"
        >
          <industry-goods-item
            v-for="(goods, indexs) in introduction.products"
            :key="indexs"
            @editgoods="editgoods"
            :iconon="iconon"
            :index="indexs + (1 % 4)"
            :index1="indexs"
            :iconoff="iconoff"
            :goods="goods"
            :itemright="itemright"
            :itemwidth="itemwidth"
          >
          </industry-goods-item>
        </div>
      </div>
      <div
        class="swiper-series-button-next swiper-button-next swiper-button-white"
        v-show="introduction.products.length > 5"
      ></div>
      <div class="swiper-pagination-box">
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
//引用swiper
import Swiper from "swiper/bundle";
//引用swiper样式
import "swiper/swiper.min.css";
import IndustryGoodsItem from "../user/IndustryGoodsItem.vue";
import IndustryTitle from "./IndustryTitle.vue";
export default {
  props: {
    classInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      introduction: {},
      title: "Related products",
      info: "相关产品",
      iconon: "icon iconfont icon-shoucang1",
      iconoff: "el-icon-star-off",
      itemright: "20px",
      itemwidth: "204px",
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getIntroduction();
  },
  watch: {},
  methods: {
    getSwiper() {
      this.gallery = new Swiper(".swiper-container-series", {
        spaceBetween: 20,
        slidesPerView: 5,
        slidesPerGroup: 5,
        navigation: {
          nextEl: ".swiper-series-button-next",
          prevEl: ".swiper-series-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          // type: 'custom',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
      });
    },
    goto(val) {
      this.$api.goods.getSearch(val, "", 1).then((res) => {
        if (res.data.datas.data.length > 0) {
          this.$router.push({
            name: "goodsinfo",
            params: { goodsid: res.data.datas.data[0].id },
          });
        }
      });
    },
    getIntroduction() {
      // console.log(this.classInfo)
      this.$api.industry.getIndustryAndClassname(this.id,this.classInfo.name).then((res) => {
        
        this.introduction = res.data.datas;
        this.$nextTick(function () {
          this.getSwiper();
        });
      });
    },
    editgoods(goodsid, index, index1, index2) {
      this.$api.goods
        .getStoreAdd(
          goodsid,
          (this.introduction.products[index1].store + 1) % 2
        )
        .then((res) => {
          if (res.data.errno == 0) {
            if (this.introduction.products[index1].store == 1) {
              this.$set(this.introduction.products[index1], "store", 0);
              this.$FUnitls.showInfo("取消收藏", "info");
            } else {
              this.$set(this.introduction.products[index1], "store", 1);
              this.$FUnitls.showInfo("已收藏", "info");
            }
          } else {
            var options = {
              message: res.data.errmsg,
            };
            Message.error(options);
          }
        });
    },
  },
  components: { IndustryGoodsItem, IndustryTitle },
};
</script>

<style  scoped>
.goods-series {
  padding-top: 28px;
  padding-bottom: 40px;
  /* background-color: red; */
  background: url(/static/industry/bj2.jpg) no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.swiper-slide {
  text-align: center;
  cursor: pointer;
}
.swiper-slide img:hover {
  transform: translateX(0) scale(1.1);
}
.img-box {
  padding: 10px 10px;
}
.img-box .img-box-item {
  padding: 10px 10px;
}
.img-box-item:hover {
  box-shadow: 0 0 6px rgba(38, 85, 174, 0.3);
}
.swiper-slide p {
  margin-top: 20px;
  font-size: 20px;
  color: #666;
}
.swiper-slide img {
  width: 80%;
  margin: 0 auto;
}
.swiper-wrapper {
  padding: 10px 0;
}
/* .swiper-slide img{
        width: 100%;
    } */
.swiper-not-enough {
  justify-content: center;
}
.brand-list {
  width: 1200px;
  position: relative;
}
.swiper-container-series {
  width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  padding: 0 10px;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  color: #d8dadb;
}



.goods-series >>> .swiper-pagination {
  left: 0;
  right: 0;
  position: absolute;
  width: 100%;
}
.goods-series >>> .swiper-pagination .swiper-pagination-bullet {
  width: 25px;
  height: 25px;
  line-height: 25px;
  border-radius: 3px;
  color: #072865;
  font-size: 12px;
  background: none;
  opacity: 1;
  margin: 0 5px;
}
.goods-series >>> .swiper-pagination .swiper-pagination-bullet-active {
  background: #2655ad;
  color: #fff;
}
.goods-series >>> .swiper-pagination-box {
  overflow: hidden;
  width: 100%;
  position: relative;
  height: 30px;
  margin-top: 15px;
}
</style>
<style>

</style>


// WEBPACK FOOTER //
// src/components/industry/IndustryGoodsList.vue